import type { StoreProduct } from './store';

const specs: Array<[string, string, StoreProduct['category'], StoreProduct['selectionMode'], string, string?]> = [
  ['재사용 케이블 타이 세트', '흩어진 선을 필요한 길이로 묶습니다.', 'desk_cable', 'universal_utility', '책상과 충전선을 쓰는 사람'],
  ['다구 케이블 고정 클립', '자주 빠지는 충전선을 책상 가장자리에 둡니다.', 'desk_cable', 'universal_utility', '여러 충전선을 함께 쓰는 사람'],
  ['비접착 케이블 홀더', '접착제 없이 책상 가장자리에 선을 고정합니다.', 'desk_cable', 'universal_utility', '책상 표면 손상을 피하고 싶은 사람'],
  ['케이블 정리 슬리브', '여러 선을 한 갈래로 모읍니다.', 'desk_cable', 'universal_utility', '모니터와 주변기기 선이 많은 사람'],
  ['데스크 분류 트레이', '매일 쓰는 작은 도구의 자리를 만듭니다.', 'desk_cable', 'universal_utility', '작은 문구가 자주 흩어지는 사람'],
  ['세로형 도구 홀더', '펜과 도구를 세워 좁은 면적에 모읍니다.', 'desk_cable', 'universal_utility', '책상 면적이 좁은 사람'],
  ['길이 조절 서랍 칸막이', '서랍 너비에 맞춰 칸을 나눕니다.', 'drawer_shelf', 'universal_utility', '서랍 속 물건이 자주 섞이는 사람'],
  ['모듈형 서랍 트레이', '서랍 크기에 맞춰 작은 칸을 조합합니다.', 'drawer_shelf', 'universal_utility', '물건 종류별 칸이 필요한 사람'],
  ['접이식 소형 수납함', '쓰지 않을 때 접어 두는 수납 공간입니다.', 'drawer_shelf', 'universal_utility', '계절마다 수납량이 달라지는 사람'],
  ['선반 하부 바스켓', '비어 있는 선반 아래 공간을 씁니다.', 'drawer_shelf', 'universal_utility', '세로 공간이 아까운 사람'],
  ['컬러 모듈 수납함', '방향과 색을 바꿔 작은 공간을 꾸밉니다.', 'drawer_shelf', 'specific_delight', '작은 방과 데스크테리어 사용자', '해외 선행 · 조합하는 손맛'],
  ['교체식 모티프 라벨 클립', '라벨과 모티프를 바꿔 수납함에 표정을 줍니다.', 'drawer_shelf', 'specific_delight', '책상 꾸미기와 라벨링을 좋아하는 사람', '귀여운 소장성'],
  ['펼치면 트레이가 되는 파우치', '지퍼를 열면 소품을 펼쳐 쓰는 작업판이 됩니다.', 'packing_pouch', 'specific_delight', '카페와 여행지에서 작업하는 사람', '해외 선행 · 변형 경험'],
  ['키보드 부품 인덱스 수납북', '스위치와 키캡을 책처럼 넘겨 찾습니다.', 'packing_pouch', 'specific_delight', '기계식 키보드 취미 사용자', '취미 정체성'],
  ['투명 소품 아카이브 파우치', '스티커와 작은 수집품을 인덱스로 보관합니다.', 'packing_pouch', 'specific_delight', '다꾸와 소품 수집 사용자', '취미 정체성 · 소장성'],
  ['한 손 슬라이드 잠금 클립', '미끄러뜨리는 한 동작으로 비식품 소품을 묶습니다.', 'packing_pouch', 'specific_delight', '반복 분류 작업의 손맛을 좋아하는 사람', '신기한 조작감'],
  ['수동 데스크 부스러기 롤러', '굴리는 동작으로 작은 부스러기를 모읍니다.', 'surface_cleaning', 'specific_delight', '책상에서 간식이나 지우개를 쓰는 사람', '해외 선행 · 만족스러운 동작'],
  ['자립형 미니 빗자루 세트', '세워 두면 작은 오브제가 되고 바로 쓸 수 있습니다.', 'surface_cleaning', 'specific_delight', '미니어처와 데스크테리어를 좋아하는 사람', '귀여운 소장성'],
  ['키보드 양면 브러시', '키캡 틈과 넓은 면을 한 도구로 바꿔 청소합니다.', 'surface_cleaning', 'specific_delight', '기계식 키보드와 전자기기를 관리하는 사람', '취미 정체성'],
  ['자립형 틈새 먼지 도구', '눈에 보이게 세워 두고 좁은 틈을 바로 닦습니다.', 'surface_cleaning', 'specific_delight', '청소 도구도 공간에 어울리길 원하는 사람', '해외 선행 · 소장성']
];

export const initialCandidateCatalog: StoreProduct[] = specs.map(([title, problem, category, selectionMode, audience, delightLabel], index) => ({
  id: `CA-SLOT-${String(index + 1).padStart(3, '0')}`,
  slug: `candidate-slot-${String(index + 1).padStart(2, '0')}`,
  title,
  problem,
  category,
  selectionMode,
  ...(delightLabel ? { delightLabel } : {}),
  audience,
  availability: 'candidate_slot',
  approvedSourceId: null,
  sourceSku: null,
  sourceCountry: null,
  approvedFulfillmentProviderId: null,
  fulfillmentSku: null,
  returnSiteRef: null,
  priceKrw: null,
  shippingKrw: null,
  dimensions: [{ label: '실측', value: '샘플 입고 후 공개', verified: false }],
  fitNotes: ['공급원 상품·3PL 재고와 실물 샘플이 확정된 뒤 호환 범위를 공개합니다.'],
  notFor: ['현재 판매 가능한 상품이 아닙니다.'],
  imageRoles: [],
  contentPacketHash: null,
  priceCheckedAt: null,
  inventoryAvailable: null,
  inventoryCheckedAt: null,
  policyVersion: 'catalog-candidate-v1',
  salesEnabled: false,
  blockedReasons: ['공급원 SKU 미선정', '국내 3PL 미계약', '실물 샘플 검수 전', '가격·재고·권리 미확정']
}));
